import { Routes, Route } from 'react-router-dom';
import Home from './user/pages/Home';
import PostDetail from './user/pages/PostDetail';
import PostList from './admin/pages/PostList';
import PostCreate from './admin/pages/PostCreate';
import PostHtmlRegenerate from './admin/pages/PostHtmlRegenerate';
import Login from './admin/pages/Login';
import NewPassword from './admin/pages/NewPassword';
import MediaUpload from './admin/pages/MediaUpload';
import MediaList from './admin/pages/MediaList';
import MediaDetail from './admin/pages/MediaDetail';
import CategoryList from './admin/pages/CategoryList';
import CategoryCreate from './admin/pages/CategoryCreate';
import TagList from './admin/pages/TagList';
import TagCreate from './admin/pages/TagCreate';
import NotFound from './user/pages/NotFound';
import ServerError from './user/pages/ServerError';
import PrivacyPolicy from './user/pages/PrivacyPolicy';
import TermsOfService from './user/pages/TermsOfService';
import About from './user/pages/About';
import Apps from './user/pages/Apps';
import AppsAnalytics from './user/pages/AppsAnalytics';
import AppsCidrPlanner from './user/pages/AppsCidrPlanner';
import MyNazcaApp from './user/pages/MyNazcaApp';
import MyNazcaDocPage from './user/pages/MyNazcaDocPage';
import ProtectedRoute from './admin/components/ProtectedRoute';
import UserLayout from './user/components/UserLayout';
import { LanguageRedirect, RootRedirect } from './shared/components/LanguageRedirect';
import { getAdminLoginPath, getAdminPostsPath, getAdminMediaListPath, getAdminCategoriesPath, getAdminTagsPath } from './shared/config/env';

/**
 * アプリケーションのルート定義
 */
export const AppRoutes = () => {
  const adminLoginPath = getAdminLoginPath();
  const adminPostsPath = getAdminPostsPath();
  const adminMediaListPath = getAdminMediaListPath();
  const adminCategoriesPath = getAdminCategoriesPath();
  const adminTagsPath = getAdminTagsPath();

  return (
    <Routes>
      {/* ルートパス（/）へのアクセス時は言語リダイレクト */}
      <Route
        path="/"
        element={<RootRedirect />}
      />
      {/* 言語付きルート */}
      <Route
        path="/:lang"
        element={
          <>
            <LanguageRedirect />
            <UserLayout>
              <Home />
            </UserLayout>
          </>
        }
      />
      <Route
        path="/:lang/posts/:slug"
        element={
          <>
            <LanguageRedirect />
            <UserLayout>
              <PostDetail />
            </UserLayout>
          </>
        }
      />
      <Route
        path="/:lang/privacy-policy"
        element={
          <>
            <LanguageRedirect />
            <UserLayout>
              <PrivacyPolicy />
            </UserLayout>
          </>
        }
      />
      <Route
        path="/:lang/terms-of-service"
        element={
          <>
            <LanguageRedirect />
            <UserLayout>
              <TermsOfService />
            </UserLayout>
          </>
        }
      />
      <Route
        path="/:lang/about"
        element={
          <>
            <LanguageRedirect />
            <UserLayout>
              <About />
            </UserLayout>
          </>
        }
      />
      <Route
        path="/:lang/apps/cidr-planner"
        element={
          <>
            <LanguageRedirect />
            <UserLayout>
              <AppsCidrPlanner />
            </UserLayout>
          </>
        }
      />
      <Route
        path="/:lang/apps/analytics"
        element={
          <>
            <LanguageRedirect />
            <UserLayout>
              <AppsAnalytics />
            </UserLayout>
          </>
        }
      />
      <Route
        path="/:lang/apps/mynazca/help/:docSlug"
        element={
          <>
            <LanguageRedirect />
            <UserLayout>
              <MyNazcaDocPage />
            </UserLayout>
          </>
        }
      />
      <Route
        path="/:lang/apps/mynazca"
        element={
          <>
            <LanguageRedirect />
            <UserLayout>
              <MyNazcaApp />
            </UserLayout>
          </>
        }
      />
      <Route
        path="/:lang/apps"
        element={
          <>
            <LanguageRedirect />
            <UserLayout>
              <Apps />
            </UserLayout>
          </>
        }
      />
      <Route path={adminLoginPath} element={<Login />} />
      <Route path="/admin/new-password" element={<NewPassword />} />
      <Route
        path={adminPostsPath}
        element={
          <ProtectedRoute>
            <PostList />
          </ProtectedRoute>
        }
      />
      <Route
        path={`${adminPostsPath}/new`}
        element={
          <ProtectedRoute>
            <PostCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={`${adminPostsPath}/:slug/edit`}
        element={
          <ProtectedRoute>
            <PostCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/posts/html-regenerate"
        element={
          <ProtectedRoute>
            <PostHtmlRegenerate />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/media"
        element={
          <ProtectedRoute>
            <MediaUpload />
          </ProtectedRoute>
        }
      />
      <Route
        path={adminMediaListPath}
        element={
          <ProtectedRoute>
            <MediaList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/media/:mediaId"
        element={
          <ProtectedRoute>
            <MediaDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path={adminCategoriesPath}
        element={
          <ProtectedRoute>
            <CategoryList />
          </ProtectedRoute>
        }
      />
      <Route
        path={`${adminCategoriesPath}/new`}
        element={
          <ProtectedRoute>
            <CategoryCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={`${adminCategoriesPath}/:id/edit`}
        element={
          <ProtectedRoute>
            <CategoryCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={adminTagsPath}
        element={
          <ProtectedRoute>
            <TagList />
          </ProtectedRoute>
        }
      />
      <Route
        path={`${adminTagsPath}/new`}
        element={
          <ProtectedRoute>
            <TagCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={`${adminTagsPath}/:id/edit`}
        element={
          <ProtectedRoute>
            <TagCreate />
          </ProtectedRoute>
        }
      />
      {/* 404 Not Found - ユーザー向けページ */}
      <Route
        path="/:lang/*"
        element={
          <>
            <LanguageRedirect />
            <UserLayout>
              <NotFound />
            </UserLayout>
          </>
        }
      />
      {/* 500 Server Error - ユーザー向けページ */}
      <Route
        path="/error"
        element={
          <UserLayout>
            <ServerError />
          </UserLayout>
        }
      />
      {/* 404 Not Found - その他のルート */}
      <Route
        path="*"
        element={
          <UserLayout>
            <NotFound />
          </UserLayout>
        }
      />
    </Routes>
  );
};


